import { useLayoutEffect, useRef } from 'react';

import { StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';
import { redirectTo } from '@/shared/lib/url/navigation';

const useImpostorRefresh = () => {
  const impostorEmail = useStorageValue(StorageKeys.Impersonator);
  const prevImpostorEmailRef = useRef<string | null | undefined>(undefined);

  useLayoutEffect(() => {
    if (prevImpostorEmailRef.current === undefined) {
      prevImpostorEmailRef.current = impostorEmail;
      return;
    }
    if (prevImpostorEmailRef.current !== impostorEmail) {
      prevImpostorEmailRef.current = impostorEmail;
      const id = setTimeout(() => {
        redirectTo('/');
      }, 250);
      return () => {
        clearTimeout(id);
      };
    }
  }, [impostorEmail]);
};

export default useImpostorRefresh;
